import React, { useState } from "react";

const doctorsData = [
  {
    name: "Dr. Abdul Mohammed",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.5/5",
    experience: "18 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
  },
  {
    name: "Dr. Prudhvinath",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location:
      "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
  },
  {
    name: "Dr. Anuj Kumar Patel",
    qualification: "MBBS, MS-General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location:
      "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
  },
  {
    name: "Dr. Ravi Sharma",
    qualification: "MBBS, MS - Surgery",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "12 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
  },
  {
    name: "Dr. Meera Iyer",
    qualification: "MBBS, DNB - Proctology",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "10 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
  },
  {
    name: "Dr. Karthik Rao",
    qualification: "MBBS, MS - Surgery",
    fee: "FREE Consultation",
    rating: "4.5/5",
    experience: "16 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
  },
];

const Doctors = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div
      style={{
        padding: "40px 15px",
        maxWidth: "1200px",
        margin: "0 auto",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Section Heading */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h2
          style={{
            fontSize: "42px",
            fontWeight: "800",
            color: "#0b1c39",
            marginBottom: "15px",
          }}
        >
          Our <span style={{ color: "#ffcb24" }}>Doctors</span>
        </h2>
        <p
          style={{
            fontSize: "18px",
            color: "#555",
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: "1.8",
          }}
        >
          Connect with top specialists and book appointments instantly.
        </p>
      </div>

      {/* Doctors List */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "25px",
          justifyContent: "space-between",
        }}
      >
        {displayedDoctors.map((doc, index) => (
          <div
            key={index}
            style={{
              flex: "0 0 calc(33.33% - 17px)",
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "20px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              border: "1px solid rgba(9,187,175,0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 12px 35px rgba(0,0,0,0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 8px 30px rgba(0,0,0,0.08)";
            }}
          >
            {/* Doctor Image */}
            <div style={{ position: "relative", flexShrink: 0 }}>
              <img
                src={doc.image}
                alt={doc.name}
                style={{
                  width: "95px",
                  height: "95px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "3px solid #09bbaf",
                  backgroundColor: "#f8f8f8",
                }}
              />
              {doc.online && (
                <span
                  style={{
                    position: "absolute",
                    bottom: "8px",
                    right: "8px",
                    width: "14px",
                    height: "14px",
                    backgroundColor: "#09bbaf",
                    borderRadius: "50%",
                    border: "2px solid #fff",
                  }}
                  title="Online"
                ></span>
              )}
            </div>

            {/* Doctor Info */}
            <div style={{ flex: 1 }}>
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#0b1c39",
                  marginBottom: "6px",
                }}
              >
                {doc.name}
              </h3>
              <p style={{ color: "#555", fontSize: "15px", marginBottom: "6px" }}>
                {doc.qualification}
              </p>
              <p
                style={{
                  fontWeight: "600",
                  color: "#09bbaf",
                  marginBottom: "6px",
                  fontSize: "15px",
                }}
              >
                {doc.fee}
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "6px",
                }}
              >
                <span style={{ fontSize: "14px", color: "#555" }}>
                  ⭐ {doc.rating}
                </span>
                <span style={{ fontSize: "14px", color: "#555" }}>
                  {doc.experience}
                </span>
              </div>
              <p
                style={{
                  fontSize: "14px",
                  color: "#555",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "6px",
                  marginBottom: "6px",
                  lineHeight: "1.4",
                }}
              >
                📍 {doc.location}
              </p>
              <p style={{ fontSize: "14px", color: "#555", marginBottom: "10px" }}>
                📞 {doc.phone}
              </p>

              <button
                style={{
                  padding: "10px 18px",
                  border: "none",
                  borderRadius: "30px",
                  backgroundColor: "#ffcb24",
                  color: "#0b1c39",
                  cursor: "pointer",
                  width: "100%",
                  fontWeight: "600",
                  fontSize: "15px",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
              >
                Book Free Appointment
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* View More Button */}
      {!showAll && doctorsData.length > 6 && (
        <div style={{ textAlign: "center", marginTop: "35px" }}>
          <button
            onClick={() => setShowAll(true)}
            style={{
              padding: "12px 35px",
              fontSize: "16px",
              borderRadius: "12px",
              border: "none",
              backgroundColor: "#09bbaf",
              color: "#fff",
              cursor: "pointer",
              fontWeight: "700",
              boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
          >
            View More Doctors ▼
          </button>
        </div>
      )}
    </div>
  );
};

export default Doctors;
